import { getCompanyPort, getPublicCompanyPort } from "@/config";
import ApiService from "@/uilts/http";

const apiService = new ApiService();

/**
 * 登陆必要参数
 */
export interface TypeApiLogin {
  name: string
  pass: string
}

/**
 * 登陆
 * @param data 登陆参数
 * @returns 返回Promise对象
 */
export const apiLogin = (data: TypeApiLogin) => {
  return apiService.post(`${process.env.VUE_APP_LOGIN_URL}/${getPublicCompanyPort()}/login`, data);
}

/**
 * 获取用户信息
 * @param data 登陆参数
 * @returns 返回Promise对象
 */
export const apiInfo = () => {
  return apiService.post(`${process.env.VUE_APP_PUBLIC_URL}/${getCompanyPort()}/public/mgr/operator/info/dh`);
}

/**
 * 修改密码
 * @param data 登陆参数
 * @returns 返回Promise对象
 */
export const apiUpdatePass = (data: {n_pass: string, o_pass: string}) => {
  return apiService.post(`${process.env.VUE_APP_PUBLIC_URL}/${getCompanyPort()}/public/mgr/updPass/dh`, data);
}

/**
 * 首页数据
 * @returns 返回Promise对象
 */
export const apiHome = () => {
  return apiService.get('/mgr/index');
}